import { render, staticRenderFns } from "./AgreementDetailHome.vue?vue&type=template&id=b72e45a2&scoped=true&"
import script from "./AgreementDetailHome.vue?vue&type=script&lang=js&"
export * from "./AgreementDetailHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72e45a2",
  null
  
)

export default component.exports